import * as Yup from 'yup';

export function specialsSchema() {
    const schema = Yup.object({
        first_name: Yup.string()
            .required('Required')
            .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
        last_name: Yup.string()
            .required('Required')
            .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
        email: Yup.string()
            .email('Invalid email')
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email')
            .required('Required'),
        phone: Yup.string().min(15, 'Invalid phone number').required('Required'),
        location: Yup.string().required('Required'),
    });
    return schema;
}

export default specialsSchema;
